var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 617,
    viewBox: "0 0 624 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_26570_3637)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.745,
    cy: 308.616,
    rx: 191.39,
    ry: 188.221,
    transform: "rotate(-0.721457 311.745 308.616)",
    fill: "url(#paint0_linear_26570_3637)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_26570_3637",
    x: 0.351562,
    y: 0.394531,
    width: 622.781,
    height: 616.445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_26570_3637"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26570_3637",
    x1: 310.799,
    y1: 403.996,
    x2: 309.603,
    y2: 498.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B6496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowCircle);
export default __webpack_public_path__ + "static/media/shadow-circle.4e26752e9c35e24efe75f51efefc6968.svg";
export { ForwardRef as ReactComponent };